import dayjs from 'dayjs'

export default {
    data() {
        return {
            currentVersion: null,
            versionJsReloadCount: 0,
            versionScript: null,
            vcLock: false,
            vcWarned: false,
            vcIntval: null,
            buildVersion: null,
        }
    },
    mounted() {
        if (!META_ENV.DEV) {
            console.info('IN_PRODUCTION_CALL_versionCheck')
            setTimeout(() => this.versionCheck_(), 30*1000) // give some time to load essential resources, go lazy
            this.vcIntval = setInterval(this.versionCheck_, 1 * 60 * 1000); //1 min
        }
    },
    beforeDestroy() {
        clearInterval(this.vcIntval)
        this.removeVcEvts()
    },
    methods: {
        removeVcEvts() {
            if (!this.versionScript) return

            this.versionScript
                // .removeEventListener('load')
                // .removeEventListener('error')
                .remove()
        },
        versionCheck_() {
            if (this.vcLock) return

            this.vcLock = true

            const versionJsUrl = this.static('build_data.js');

            this.removeVcEvts()

            var self = this

            this.versionScript = document.createElement('script');
            document.head.appendChild(this.versionScript);
            this.versionScript.src = [versionJsUrl, '?rc=', dayjs().unix()].join('');
            this.versionScript.addEventListener('load', () => {
                // script has finished loading
                // console.log(this.versionScript.innerHTML);
                self.vcLock = false

                if (!build_data?.version) {
                    return
                }

                //already loaded version at least once
                if (self.buildVersion && String(self.buildVersion) != String(build_data.version)) {
                    // alert("Application has been updated. Please reload")
                    console.info('vcWarned', String(self.buildVersion), String(build_data.version))
                    self.vcWarned = true
                }

                self.buildVersion = build_data.version
                window.x_build_version = build_data.version
            });
            this.versionScript.addEventListener('error', () => {
                // error occurred while loading the script
                console.error('build_check_error')
                self.vcLock = false
            });
        },
    }
}